<!--
 * @Author: your name
 * @Date: 2022-02-28 16:33:33
 * @LastEditTime: 2022-10-22 14:56:20
 * @LastEditors: pyx 3245266940@qq.com
 * @Description: 电子合同 签署合同
 * @FilePath: \wx-front\src\views\contract\signContract.vue
-->
<template>
<div class="wrap" id="signContract">
    <div class="topBox rowAc fontH3 fontScN10 ">
        <div class="textOver">{{title}}</div>  
    </div>

    <div class="contentBox fontMcA1 fontH2" id='contentBox'>
        <div class="pagesBox fontScW fontH3 rowJcAc">{{currentPage+'/'+numPages}}</div>

        <div v-for="i in numPages" :key="i" class="pdfBox" id='pdfBox'>  
            <pdf
                ref="pdf"
                :key="i"
                :src="src"
                :page="i"
                @loaded="loadPdfHandler"
            ></pdf>
        </div>

        

        <div class=" fontH4 fontScN9" v-for="(item,index) in controls" :key="index+'controls'">
            <div v-if="item.controlType == 1" class="pdfdiv rowAc" v-bind:style="{ width: item.controlWidth*pdfRate+ 'px', height: item.controlHeight*pdfRate + 'px',top: (item.controlTop+24)*pdfRate+44 + 'px',left: item.controlLeft*pdfRate + 'px',transform: 'scale('+pdfRate+')',transformOrigin: 'left'}">{{item.controlValue}}</div>
            
            <div v-if="item.controlType == 2 && item.controlValue" class="pdfImg" v-bind:style="{ width: item.controlWidth*pdfRate+ 'px', height: item.controlHeight*pdfRate + 'px',top: (item.controlTop+24)*pdfRate+44 + 'px',left: item.controlLeft*pdfRate + 'px',backgroundImage: 'url('+item.controlValue+')'}"></div>

            <!-- <img v-if="item.controlType == 2 && item.controlValue" :src="item.controlValue" class="pdfImg" v-bind:style="{ width: item.controlWidth*pdfRate+ 'px', height: item.controlHeight*pdfRate + 'px',top: (item.controlTop+24)*pdfRate+44 + 'px',left: item.controlLeft*pdfRate + 'px'}" alt=""> -->
        </div>

        <div v-if="!isSigned" style="width:100%;height:64px"></div>
    </div>
    

    <div class="bottomBox rowJcAc fontH3" v-if="!isSigned">
        <div v-if="!isSign" class="rejectBtn bottomBtn fontMcA1 borderMcA1 rowJcAc medium" @click="rejectSign">拒签</div>
        <div v-if="!isSign" class="signBtn  bgcMcA1 rowJcAc fontScW bottomBtn medium"  @click="clickSign">签署</div>
        <div v-if="isSign" class="rejectBtn bottomBtn fontMcA1 borderMcA1 rowJcAc medium" @click="clickSign">修改签章</div>
        <div v-if="isSign" class="signBtn  bgcMcA1 rowJcAc fontScW bottomBtn medium"  @click="finishSign">完成签署</div>
    </div>
    
    <van-popup
        v-model="signShow"
        round
        position="bottom"
        custom-style="height: 20%"
        bind:close="onClose"
    >
        <div class="signBox">
            <div class="boxTop rowJbAc">
                <div class="fontScN8 medium fontH2">签署</div>
                <div class="fontScN7" :class="[isDelete?'redColor':'']" @click="clickDelete">{{isDelete?'确认删除':'删除签名'}}</div>
            </div>

            <div class="signItemBox flexRow">
                <div class="signItem colJcAc marginRight">
                    <div class="signBgd bgcScN1 rowJcAc" @click="addSign">
                        <div class="colJcAc">
                            <img src="../../assets/static/contract/add.svg" class="addImg" alt="">
                            <div class="fontScN6">添加</div>
                        </div>
                    </div>
                    <div class="fontScN7">手写签名</div>
                </div>

                <div class="signItem colJcAc " v-for="(item,index) in signImgList" :key="index" :class="[(index+2)%3 === 0 ? '':'marginRight']">
                    <div class="signBgd bgcScN1 rowJcAc " :class="[item.isSelected&& isDelete?'activedStatus':'']" @click="checkSelect(item)">
                        <img :src="item.imageUrl" class="signImg" alt="">
                        <img v-if="!item.isSelected && isDelete" src="../../assets/static/contract/unchecked-circle.svg" class="circleImg" alt="">
                        <img v-if="item.isSelected && isDelete" src="../../assets/static/contract/actived-circle.svg" class="circleImg" alt="">
                    </div>
                    <div class="fontScN7">手写签名</div>
                </div>
            </div>
            
        </div>
    </van-popup>
    <van-dialog id="van-dialog" />
</div>
</template>

<script>
import { getSignatureListAPI,deleteSignatureAPI,putRejectContractAPI,} from "../../utils/api/contractAPI";
import pdf from 'vue-pdf'
export default {
    name: 'signContract',
    components:{
      pdf
  },
  data() {
    return {
        signShow:false,//签名弹框展示与否
        signImgList:[//签名图片数组
            // {imageUrl: require('../../assets/static/contract/finishImg.svg'),id:1,isSelected:false},
        ],
        isDelete:false,//是否处于删除签名的状态
        selectedList:[],//选中的签名的id的数组

        pageCount: 0, // pdf文件总页数

        numPages: null, //pdf页数
        // src: '/static/1111.pdf', //pdf文件src
        currentPage: 1, //pdf当前页数
        src:"",//pdf地址
        parentUid:'',//客户id
        campusCode:'',//校区code
        detailData:{},//合同详情
        controls:[],//控件
        pdfRate:'',//pc端和移动端的宽度比
        isSign:false,//判断是否已经签名
        signatureIndex:'',//记录家长签名所在controls的index
        isSigned:false,//判断合同状态是否为已签署的，已签署的合同不能在修改
        title:'',//合同名称
    };
  },
   computed: {
    },
    beforeRouteLeave(to, from, next) {
            if (to.path == "/autograph" || to.path == "/verification") {
            // from.meta.keepAlive = true
            } else {
            this.$bus.$emit("pageEvent", { pageName: "signContract", type: "del" });
            // from.meta.keepAlive = false
            }
            next();
        },
    activated() {
         console.log('kkk-----ooo--',this.$route.params,this.controls)
        this.signShow = false
        if(this.$common.getCache('url')){
            this.controls[this.signatureIndex].controlValue = this.$common.getCache('url')
            this.isSign = true
            this.$common.removeCache('url')
        }
        
    },
    deactivated() {
        console.log('deactivated-0---')
    },
    created() {　　
        console.log('created-0---')
        this.$bus.$emit("pageEvent", { pageName: "signContract", type: "add" });
     
          this.src = this.$route.params.detailData.templateFileUrl
          this.detailData = this.$route.params.detailData
          this.title = this.detailData.title
          if(this.detailData.status==1){
              this.isSigned = false
          }else{
              this.isSigned = true
          }
          
      
    },
  mounted() {
      console.log('mounted-------pppp')
    this.getCampusInfo()

      this.getNumPages();
      var that = this
       document.getElementById('signContract').addEventListener('touchmove', function (e) {
           var pages = (document.getElementById('contentBox').scrollTop+(document.getElementById('pdfBox').offsetHeight/2)) / document.getElementById('pdfBox').offsetHeight
           
          that.currentPage = Math.ceil(pages)


        //   console.log('kkk---',document.getElementById('pdfBox').offsetHeight,document.documentElement.scrollHeight,document.getElementById('contentBox').scrollTop,pages,that.currentPage)
       }, { passive: false })

       console.log('container宽度----793--217--504--133',document.getElementById('contentBox').offsetWidth)
       var mobilePdfWidth = document.getElementById('contentBox').offsetWidth
        this.pdfRate = mobilePdfWidth/595
       console.log('pdfRate-----',this.pdfRate)
       this.controls = this.detailData.controls
        this.controls.forEach((controlsItem,controlsIndex)=>{
            if(controlsItem.controlFieldKey == 'parent.signature'){
                this.signatureIndex = controlsIndex
            }
            if(controlsItem.controlFieldKey == "parent.signature.date"){
                controlsItem.controlValue = this.$common.getNowDateTime()
            }
        })

      
  },
  methods: {
        
       //计算pdf页码总数
        getNumPages() {
            const loadingTask = pdf.createLoadingTask(this.src)
            loadingTask.promise.then(pdf => {
                console.log('计算pdf页码总数', pdf,pdf.numPages);
                this.numPages = pdf.numPages
            }).catch(err => {
                console.error('pdf 加载失败', err);
            })
        },
  

      // pdf加载时
      loadPdfHandler (e) {
        this.currentPage = 1 // 加载的时候先加载第一页
      },






    //点击添加签名
    addSign(){
        this.$router.push({
            name: "Autograph",
            // params: { submit: true },
        });
    },
    //选择某个签名，改变选中的状态
    checkSelect(item){
        if(this.isDelete){
            item.isSelected = !item.isSelected
        }else{
            this.controls[this.signatureIndex].controlValue = item.imageUrl
            this.isSign = true
            this.signShow = false
        }
        
    },
    //点击拒签
    rejectSign(){
        var obj = {
            customerId: this.parentUid,
            id:this.detailData.id,
            status:3
        }
        putRejectContractAPI(obj).then(res => {
            if(res.resultCode == 200) {
                // this.$router.push({
                //     name: "ContractList",
                //     // params: { submit: true },
                // });
                this.$router.go(-2)
            }
        })
        
    },
    //点击完成签署
    finishSign(){
        this.$router.push({
            name: "Verification",
            params: { customerId: this.parentUid,id:this.detailData.id,signatureImageUrl:this.controls[this.signatureIndex].controlValue },
        });
    },
    //点击签署
    clickSign(){
        this.getSignatureList()
    },
    //点击删除签名
    clickDelete(){
        if(!this.isDelete){
            this.isDelete = true
        }else{
            this.selectedList = []
            this.signImgList.forEach(item=>{
                if(item.isSelected){
                    this.selectedList.push(item.id)
                }
            })
            if(this.selectedList.length==0){
                this.isDelete = false
            }else{
                this.$dialog.confirm({
                title: '确认删除',
                message: '确认删除该签名吗？',
                })
                .then(() => {
                    var obj = {
                        ids: this.selectedList.join(','),
                        customerId: this.parentUid
                    }
                    deleteSignatureAPI(obj).then(res => {
                        if(res.resultCode == 200) {
                            var arr = []
                            this.signImgList.forEach(item=>{
                                if(!this.selectedList.includes(item.id)){
                                    arr.push(item)
                                }
                            })
                            this.signImgList = arr
                            this.selectedList = []
                            this.isDelete = false

                        }
                    })
                    
                })
                .catch(() => {
                    // on cancel
                });
            }
        }
        
    },
    // 获取签名列表
    getSignatureList() {
        var obj = {
            customerId: this.parentUid,
        }
        getSignatureListAPI(obj).then(res => {
            if(res.resultCode == 200) {
                console.log('获取签名列表-----',res)
                if(res.data){
                    res.data.forEach(item=>{
                        item['isSelected'] = false
                        item.imageUrl = item.imageUrl+'?x-oss-process=image/rotate,270'
                    })
                    this.signImgList = res.data
                }else{
                    this.signImgList = []
                }
                this.signShow = true

            }
        })
    },
    // 获取校区信息
    getCampusInfo() {
        if(this.$common.getCache('campusItem')) { // 判断本地有无校区信息
            var campusItem = JSON.parse(this.$common.getCache('campusItem'))
            this.parentUid = campusItem.customerId
            this.campusCode = campusItem.campusCode
        }else {
            var campusList = JSON.parse(this.$common.getCache('customerAuthList'))
            if(campusList) {
                this.campusCode = campusList[0].campusCode
                this.parentUid = campusList[0].customerId
            }
        }
        
    },


  },
};
</script>
<style lang="scss" scoped>
.wrap {  
background: #F5F6F9;
height: 100%;
font-size: 14px;
padding: 0.16rem;
box-sizing: border-box;
}
.contentBox{  
    height: 100%;  
    padding:44px 0 0 0;
    background: #FFFFFF;
    box-sizing: border-box;
    overflow: auto;
    position: relative;
}
.bottomBox{
    width: 100%;
    // height: 64px;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #FFFFFF;
    padding: 8px 16px 8px 16px;
    box-sizing: border-box;
}
.topBox{
    width: 100%;
    height: 44px;
    position: fixed;
    top: 0;
    left: 0;
    background: #FFFFFF;
    padding: 0 0.16rem;
    box-sizing: border-box;
    box-shadow: 0px 2px 1px 1px rgba(0,0,0,0.04);
    z-index: 9999;
}
.signBtn,.rejectBtn{
    
    height: 48px;
    border-radius: 6px;
}
.rejectBtn{
    margin-right: 0.12rem;
    box-sizing: border-box;
    border: 1px solid;
}
.bottomBtn{
    flex: 1;
}
.signBox{
    width: 100%;
    // min-height: 218px;
    // max-height: 500px;
    background-color: #FFFFFF;
    padding: 16px 24px;
    box-sizing: border-box;
    // position: relative;
}
.signBgd{
    width: 1rem;
    height: 1rem;
    border-radius: 2px;
    margin-bottom: 8px;
    position: relative;
    box-sizing: border-box;
}
.addImg{
    width: 0.14rem;
    height: 0.14rem;
    margin-bottom: 4px;
}
.boxTop{
    margin-bottom: 17px;
}
.signImg{
    // width: 0.98rem;
    // height: 0.98rem;
    width: 100%;
    height: 100%;
    border-radius: 2px;
}
.marginRight{
    margin-right: 0.13rem;
}
.signItemBox{
    flex-wrap: wrap;
    min-height: 218px;
    max-height: 500px;
    overflow: auto;
}
.redColor{
    color: #FA3F3F;
}
.circleImg{
    position: absolute;
    top: 6px;
    right: 6px;
    width: 0.2rem;
    height: 0.2rem;
}
.activedStatus{
    border: 1px solid #1A7AF8;
}
.signItem{
    margin-bottom: 16px;
}
.pagesBox{
    height: 24px;
    background: #000000;
    border-radius: 12px;
    opacity: 0.5;
    padding: 0 0.12rem;
    box-sizing: border-box;
    position: fixed;
    top: 56px;
    right: 0.16rem;
    z-index: 9999;
    // position: absolute;
    // top: 0;
    // right: 0;

}
.pdfBox{
    position: relative;
}
.pdfdiv,.pdfImg{
    position: absolute;
}
.pdfImg{
    // background-color: pink;
     background-size: contain;
    background-repeat: no-repeat;
}

</style>
